import { render, staticRenderFns } from "./ProductWrapper.vue?vue&type=template&id=3f2b560e&"
import script from "./ProductWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports